module.exports = __webpack_public_path__ + "static/media/7.cd7acf14.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/7.jpg
// module id = 70
// module chunks = 0